<div class="mb-3 ms-2" style="width: 690px;">
    <p class="mb-1" *ngIf="similarProjects && tabId === 'projects'">Displaying the {{similarProjects.length}}
        most similar {{tabId}}.</p>
    <p class="mb-1" *ngIf="similarPublications && tabId === 'publications'">Displaying
        the {{similarPublications.length}} most similar {{tabId}}.</p>

    <p class="mb-1">The similarity is computed by comparing the project titles and abstracts as well as the
        publication titles and abstracts with the project title and abstract of the current row.</p>

    <a href="{{buildUrlFilteringByProjectCodes(similarProjects)}}" target="_blank" rel="noopener"
       *ngIf="similarProjects && tabId === 'projects'" class="d-block mt-2">
        Open projects in a new tab <span class="fal fa-external-link text-primary "></span>
    </a>
    <a href="{{buildUrlFilteringByBibCodes(similarPublications)}}" target="_blank" rel="noopener"
       *ngIf="similarPublications && tabId === 'publications'" class="d-block mt-2">
        Open publications in a new tab <span class="fal fa-external-link text-primary "></span>
    </a>
</div>